import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export const usePreTrackeUserParamsStore = create(
  persist(
    (set) => ({
      preTrackeUserParams: null,
      isOptedOut: false,
      emailConsentState: null,
      setPreTrackeUserParams: (preTrackeUserParams) => set({ preTrackeUserParams }),
      setIsOptedOut: (isOptedOut) => set({ isOptedOut }),
      setEmailConsentState: (emailConsentState) => set({ emailConsentState }),
    }),
    {
      name: 'pre-tracker-user-params-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        emailConsentState: state.emailConsentState,
      }),
    },
  ),
);
